<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-出库-添加
    -->
    <el-dialog
    title="添加出库"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%" 
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">基本信息</div>
      
      <el-form-item label="流程：" >
          <el-steps :active="activeStep" align-left>
              <el-step title="从哪出库" description="选择厂家"></el-step>
              <el-step title="" description="选择商品"></el-step>
              <el-step title="出库到哪" description="选择平台库位"></el-step>
              <el-step title="" description="入库"></el-step>
          </el-steps>
      </el-form-item>
      
      <el-form-item label="出库类型：" >
          <el-radio-group v-model="form.type">
            <!-- <el-radio :label="0">线下出库(会产生销售订单)</el-radio> -->
            <!-- <el-radio :label="1">线下出库(不产生销售订单，用于其它批发点入库)</el-radio> -->
            <el-radio :label="2" v-if="isuse == 1" >线下出库(不产生销售订单，用于其它批发点入库)</el-radio>
            <el-radio :label="3">线下出库(手动帮门店下单)</el-radio>
          </el-radio-group>
        </el-form-item>

      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
    
          <csupply @choose1="choose1"  @choose2="choose2" @choose3="choose3" :type="form.type"></csupply>

        </div>


      </div>

      <div class="common-form" v-if="form.type == 2">可选操作</div>   
      <el-form-item label="操作" v-if="form.type == 2" >
          <el-radio-group v-model="form.op" >
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">直接入库到对应批发点库位下</el-radio>
          </el-radio-group>
        </el-form-item>






        <div class="common-form">出库清单</div>   
        <el-button icon="el-icon-plus" @click="changeProduct(form.product)">选择出货商品</el-button>
        
        <div class="d-s-c pt16 max-w460 active-all-set">
        <div style="width: 60px;">批量设置：</div>
        <div class="flex-1"><el-input v-model="set_num" type="number" min="0" placeholder="数量"></el-input></div>



        <div>
      
          <div v-if="form.op == 1">
                
                <el-select v-model="rk_warehouse_kw_id">
                    <template v-for="item in warehouse" >
                      <el-option
                        value="0"
                          :key="item.warehouse_id"
                        :label="item.name"
                         prop="warehouse_kw_id"

                      ></el-option>
                      <template v-if="item.warehousekw !== undefined" v-for="itemA in item.warehousekw">
                        <el-option
                          :value="itemA.warehouse_kw_id"
                          :key="itemA.warehouse_kw_id"
                          :label="itemA.name"
                          style="padding-left: 30px"
                        ></el-option>
                    
                      </template>
                    </template>
                </el-select>
         
            </div>

        </div>
  
        <div class="ml10"><el-button @click="allApply">应用</el-button></div>
      </div>

      <div style="line-height: 24px; font-size: 14px;font-weight: 600;">每次代店下单只能选择一个门店</div>

        
        <el-table size="small" :data="form.product"   border style="overflow-y: auto;  width: 100%;height:400px;" v-loading="loading">
 
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
          <el-table-column prop="set_num" label="数量">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.set_num"
                @input="updateAmount(scope.row)"
                placeholder="请输入数量"
                type="number"
              ></el-input>

            </template>

          </el-table-column>
          <el-table-column prop="product_price" label="单价">
             <template slot-scope="scope">
            
             <el-input
                v-model="scope.row.product_price"
                @input="updateAmount(scope.row)"
                placeholder="请输入单价"
                type="number"
              ></el-input> 
            </template>

          </el-table-column>
          <el-table-column prop="amount" label="金额"></el-table-column>

          <el-table-column prop="rk.price" label="出库金额"></el-table-column>
             
          <el-table-column prop="supply_id" label="从哪出库"></el-table-column>
          <el-table-column prop="t_supply_id" label="入库到哪"></el-table-column>

          <el-table-column prop="warehouse_kw_id" label="选择入库库区" v-if="form.op == 1">
            <template slot-scope="scope">
                <div>
                
                    <el-select v-model="scope.row.rk_warehouse_kw_id">
                        <template v-for="item in warehouse" >
                          <el-option
                            value="0"
                              :key="item.warehouse_id"
                            :label="item.name"
                             prop="warehouse_kw_id"

                          ></el-option>
                          <template v-if="item.warehousekw !== undefined" v-for="itemA in item.warehousekw">
                            <el-option
                              :value="itemA.warehouse_kw_id"
                              :key="itemA.warehouse_kw_id"
                              :label="itemA.name"
                              style="padding-left: 30px"
                            ></el-option>
                        
                          </template>
                        </template>
                    </el-select>
             
                </div>
             
              </template>

          </el-table-column>


          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>


          <!-- 自定义插入一行 -->
          <template v-slot:append  v-if="form.product">
            
            <div style="float: right;">
              <tr class="custom-footer" style="border: 1px solid red;height: 50px;">
              <!-- 合并列 --> 
             
          
                <td style="font-size: 20px;width: 100px;float: right;line-height: 50px; text-align: center; background-color: #f5f5f5;">
                  {{ form.totalAmount }}
                </td>
                <td  style="font-size: 20px; width: 100px;float: right;line-height: 50px; text-align: center; font-weight: bold; background-color: #f5f5f5;">
                  总计
                </td>
              <div style="clear: both;"></div>
            </tr>
            </div>
            
       
          </template>
        </el-table>

      

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
     </div>



  <Batch :isBatch="isBatch" :excludeIds="excludeIds"
   :choose_supply_id="form.supply_id" 
   :t_supply_id = "form.t_supply_id"
  :store_id="form.store_id"
  :islist="islist" @closeDialog="closeDialogFuncBatch"></Batch>

 </el-dialog>
  
</template>

<script>
  import PorductApi from '@/api/product.js';
import Out_managementApi from '@/api/out_management.js';
import Batch from '@/components/product/batch';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Supply from '@/components/supply/supply_commonx.vue';
import {mergeTable} from '@/utils/table.js'
import Store from '@/components/store/Store.vue';

import Warehouse_managementApi from '@/api/warehouse_management.js';
import csupply from  '@/components/supply/new/supply.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Supply,
     Store,
     csupply,
     Batch

  },

  data() {
    return {
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        amount:0,
        type:2,
        product:[],
        totalAmount:0,
        t_supply_id:0,
        supply_id:0,
        supply:{},
        store_id:0,
        op:0,

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入出库名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      isBatch:false,
      activeStep: 4, // 当前步骤


      batchData:[],
        formInline_batch:{
            search_batch:"",
        
 

        },
            /*当前是第几页*/
            curPage_batch: 1,
        /*一页多少条*/
        pageSize_batch: 10,
        totalDataNumber_batch:0,

        choose_supply_id:0,
        multipleSelection:[],


        multi:false,
        is_open:false,
        store:{},
        set_num:0,
        rk_warehouse_kw_id:0,

        warehouse:[],
        isuse:0
    };
  },
  created() {
    if(this.type){
      this.form.type = this.type;

    }
    this.getBData();
    this.dialogVisible = this.open_add;

    var self = this;
    self.getInas({},function(res){
      console.log(res)
      self.isuse = res
      if(self.isuse == 0){
        self.form.type = 3
        self.$forceUpdate();

      }
    })


  },
  props: ["open_add",'type'],
  methods: {

    getWarehouse(){
      var self = this;
      var parmas = {};
      parmas = {
          supply_id: this.form.t_supply_id,
        }
      Warehouse_managementApi.getWarehouse(parmas, true)
            .then(data => {
 
              self.warehouse = data.data;
            })
            .catch(error => {
     
            });
    },
    closeDialogs(e){

    },
    choose1(item){
      this.form.supply_id = item.id
    },
    choose2(item){
      this.form.t_supply_id = item.id
      this.getWarehouse();
    },
    choose3(item){
      this.form.store_id = item.id
    },
    addClick(){
        this.is_open = true;
    },
    closeStore(e){
      var parmas = e.params
      this.form.store_id = parmas.store_id;
      this.store = parmas
      this.is_open = false;
    },
    remove(){
      this.form.store_id = 0;
    },
    exportB(row){
    
    let baseUrl = window.location.protocol + '//' + window.location.host;
    window.location.href = baseUrl + '/index.php/shop/product.product/exportPandian?'+'supply_id='+row.supply_id;
  },
        /*每页多少条*/
        handleSizeChange(val) {
      this.curPage_batch = 1;
      this.pageSize_batch = val;
       this.getBData();
    },
        /*监听复选按钮选中事件*/
        tableCurrentChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val){
       // this.searchForm.warehouse_id = val.warehouse_id
       // this.searchForm.warehouse_kw_id = val.warehouse_kw_id
       // this.getData();
      },
       /*获取商品列表*/
       getBData() {
        let self = this;
        let params = self.formInline_batch;
        params.page = self.curPage_batch;
        params.list_rows = self.pageSize_batch;
        PorductApi.getBatch(params, true)
          .then(res => {
            if (res.code == 1) {
              self.loading = false;
              self.batchData = res.data.list.data;
              self.totalDataNumber_batch = res.data.list.total;
            }
          })
          .catch(error => {});
      },

      selectB(row){
        // this.supply_id = row.supply_id
        // console.log('row.supply_id',row.supply_id);
        this.choose_supply_id =  row.supply_id
        // this.getData()
      },


     // 更新金额（当修改单价时）
     updateAmount(row) {
      row.amount = (row.product_price * row.set_num).toFixed(2);
      this.updateTotalAmount();  // 更新总金额
    },
     // 更新总金额
     updateTotalAmount() {
      this.form.totalAmount = this.form.product.reduce((acc, row) => parseFloat(acc) + parseFloat(row.amount), 0);
      this.$forceUpdate()
    },
    del(index){
      this.form.product.splice(index,1)
    },
     /*全部应用*/
     allApply() {
      let arr = [];
      for (let i = 0; i < this.form.product.length; i++) {
        let item = this.form.product[i];
  
        item.set_num = this.set_num;
        item.rk_warehouse_kw_id = this.rk_warehouse_kw_id
        this.updateAmount(item);
      }
    },
    closeDialogFuncBatch(e) {
 
      const self = this
      self.isBatch = false
      
      if (e.type === 'success') {
        // 创建哈希表用于快速查找重复项
        const existingMap = new Map()
        self.form.product.forEach(item => {
          const key = `${item.product_sku_id}|${item.product_id}|${item.warehouse_kw_id}|${item.supply_id}|${item.t_supply_id}`
          existingMap.set(key, item)
        })

        // 处理新数据
        const mergedProducts = e.params.map(item => {
          const key = `${item.product_sku_id}|${item.product_id}|${item.warehouse_kw_id}|${self.form.supply_id}|${self.form.t_supply_id}`
          // 如果已存在相同产品，则合并数量并更新价格
          if (existingMap.has(key)) {
            const existing = existingMap.get(key)
            existing.set_num += 1  // 累加数量
            existing.product_price = item.product_price  // 更新为最新单价
            return existing
          }

          // 创建新条目
          return {
            t_supply_id:self.form.t_supply_id,
            supply_id:self.form.supply_id,
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            warehouse_kw_id: item.warehouse_kw_id,
            warehousekwtext: item.warehousekwtext,
            warehousetext: item.warehousetext,
            unit: item.unit,
            spec_value: item.spec_value,
            status: 0,
            set_num: 1,
            file_path: item.image.file_path || '',
            rk: item.warehouse_management,
            category_name: item.category_name,
            batchNumber: item.batchNumber
          }
        })

        // 去重合并（使用Set去除重复引用）
        self.form.product = [...self.form.product, ...mergedProducts]
          .filter((v, i, a) => a.findIndex(t => (
            t.product_sku_id === v.product_sku_id &&
            t.product_id === v.product_id &&
            t.warehouse_kw_id === v.warehouse_kw_id &&
            t.t_supply_id === v.t_supply_id &&
            t.supply_id === v.supply_id
          )) === i)

        // 批量更新金额
        mergedProducts.forEach(item => {
          self.updateAmount(item)
        })

        this.getWarehouse()
      }
    },

    /*打开添加*/
    changeProduct(list) {
      var self = this;
      let arr = [];
      if(self.form.supply_id <= 0 ||self.form.supply_id == undefined){
        this.$message.error("请选择出货渠道");
        return;
      }
  
      if((self.form.t_supply_id <= 0 || self.form.t_supply_id == undefined) && self.form.type == 2){
        this.$message.error("请选择出货到哪");
        return;
      }

      if(self.form.store_id <= 0 && self.form.type == 3){
        this.$message.error("请选择下单门店");
        return;
      }
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isBatch = true;
    },

     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      if(self.form.supply_id <= 0 ||self.form.supply_id == undefined){
        this.$message.error("请选择出货渠道");
        return;
      }
  
      if((self.form.t_supply_id <= 0 || self.form.t_supply_id == undefined) && self.form.type == 2){
        this.$message.error("请选择出货到哪");
        return;
      }

      if(self.form.store_id <= 0 && self.form.type == 3){
        this.$message.error("请选择下单门店");
        return;
      }

      if(self.form.product.length <= 0){
        this.$message.error("请选择出货商品");
        return;
      }

      if(self.form.op == 1){
        var product = self.form.product;
        var ind = 0;
        for(var i=0;i<product.length;i++){
            if(product[i].rk_warehouse_kw_id == '0' || !product[i].rk_warehouse_kw_id){
                ind++;
            }
        }
        if(ind > 0){
            self.$message({
              message: '请选择库位',
              type: 'error'
            });
          return false;
        }    
      }
   



      if(self.form.type == 2){
        self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Out_managementApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
      }else if(self.form.type == 3){
        self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Out_managementApi.adda(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
      }
   
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.process-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.button-container {
  margin-top: 20px;
  text-align: center;
}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/out_management/index/part/add.vue